import React from "react";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function PagesHero({ title, description, backgroundImage, hideLearnMore }) {
  const [topButtonRef, topButtonVisible] = useScrollAnimation();
  const [textRef, textVisible] = useScrollAnimation();
  const [buttonsRef, buttonsVisible] = useScrollAnimation();
  const { t } = useTranslation();

  const backgroundStyle = backgroundImage
    ? {
        backgroundImage: `linear-gradient(269.88deg, rgba(0, 0, 0, 0) 0.1%, rgba(0, 0, 0, 0.8) 58.57%), url(${backgroundImage})`,
      }
    : {};

  return (
    <div className="pageshero-wrapper" style={backgroundStyle}>
      <div className="pageshero container">
        <button
          ref={topButtonRef}
          className={`top-button fs-500 uppercase clr-green ${
            topButtonVisible ? "animate-in" : ""
          }`}
        >
          {t("header.products")}
        </button>
        <div
          ref={textRef}
          className={`pageshero-text ${textVisible ? "animate-in" : ""}`}
        >
          <h1 className="fs-900 clr-white">{title}</h1>
          <p className="clr-white fs-500">{description}</p>
        </div>
        <div
          ref={buttonsRef}
          className={`flex main-buttons ${buttonsVisible ? "animate-in" : ""}`}
        >
          <Link to="/contact">
            <button className="main-button main-header-button fs-500 clr-white transition pointer">
              {t("banner.contactUs")}
            </button>
          </Link>
          {!hideLearnMore && (
          <Link to="/about">
            <button className="main-button fs-500 clr-white transition pointer">
              {t("banner.learnMore")}
            </button>
          </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default PagesHero;
